
export enum DirectSaleState {
  Draft= 'Draft',
  ToBeApproved= 'ToBeApproved',
  ToBeScheduled= 'ToBeScheduled',
  Waiting= 'Waiting',
  Pending= 'Pending',
  Open= 'Open',
  Closed= 'Closed',
  Canceled= 'Canceled',

}